// extracted by mini-css-extract-plugin
export default {"buttonBox":"TableContainer_buttonBox__f9NVy","isCenter":"TableContainer_isCenter__+q2Ui"};